module.exports = __webpack_public_path__ + "static/media/asterisk.3d9fa666.svg";